import {
  ArtifactFormModel,
  ArtifactFormType,
} from '../components/ArtifactForm/ArtifactForm.types';

import ExameForm from './Exame';
import MedicamentoForm from './Medicamento';
import EncaminhamentoForm from './Encaminhamento';
import OrientacoesForm from './Orientacoes';
import ProcedimentoForm from './Procedimento';
import AgendamentoForm from './Agendamento';

const FormModel: Record<ArtifactFormType, ArtifactFormModel> = {
  agendamento: AgendamentoForm,
  encaminhamento: EncaminhamentoForm,
  'orientacoes-medicas': OrientacoesForm,
  'prescricao-medica': MedicamentoForm,
  'solicitacao-exame': ExameForm,
  procedimento: ProcedimentoForm,
};

export function getForm(formType: ArtifactFormType): ArtifactFormModel {
  const form = FormModel[formType];

  if (form === undefined) {
    throw new Error(
      `Não existe uma configuração de formulário disponível para o tipo "${formType}".`,
    );
  }

  return form;
}

export default FormModel;
